import { apiWithQuery, EventType_Create, EventType_Update, EventType_UpsertAll, ModuleFE_BaseApi, ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_User, DBDef_User } from '@app/org-shared';
import { LoggedStatus, ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { asArray } from '@nu-art/ts-common';
export const dispatch_onUsersUpdated = new ThunderDispatcherV3('__onUsersUpdated');
export const dispatch_onMyUserReceived = new ThunderDispatcher('__OnUserLoggedIn');
export class ModuleFE_User_Class extends ModuleFE_BaseApi {
    _v1;
    loggedUser;
    __searchFilterMapper = (user) => [user.firstName || user._id];
    __searchGroups = (users) => ([{
            group: this.dbDef.entityName,
            results: users.map(user => ({ _id: user._id, uiLabel: user.firstName || user._id }))
        }]);
    __onUsersUpdated = (...params) => {
        switch (params[0]) {
            case EventType_Update:
            case EventType_Create:
            case EventType_UpsertAll: {
                // Currently we only listen in order to update the logged in user if data about it has changed. The system is supposed to not hold any user data besides the logged in user.
                const selfUser = asArray(params[1]).find(_user => _user._id === this.loggedUser?._id);
                if (selfUser)
                    this.loggedUser = selfUser;
            }
        }
    };
    __onLoginStatusUpdated = async () => {
        if (!ModuleFE_Account.isStatus(LoggedStatus.LOGGED_IN))
            return;
        this._v1.getMyUser({}).execute(this.setLoggedUser);
    };
    constructor() {
        super(DBDef_User, dispatch_onUsersUpdated);
        this._v1 = {
            getMyUser: apiWithQuery(ApiDef_User._v1.getMyUser)
        };
    }
    getUser = () => {
        return this.loggedUser;
    };
    setLoggedUser = (user) => {
        this.loggedUser = user;
        dispatch_onMyUserReceived.dispatchUI();
    };
}
export const ModuleFE_User = new ModuleFE_User_Class();
//# sourceMappingURL=ModuleFE_User.js.map